function useStyles({ minHeaderHeight }: { minHeaderHeight?: number | string } = {}) {
  return {
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0px 0px 6px 1px rgba(0,0,0,0.15)',
    },
    scrollableContainer: {
      width: '100%',
      height: '100%',
      maxHeight: 'calc(100vh - 350px)',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 'none',
      boxShadow: '0px 0px 6px 1px rgba(0,0,0,0.15)',
      overflow: 'hidden',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      padding: '10px 16px',
      borderBottom: '2px solid',
      borderColor: 'primary.100',
      flexShrink: 0,
      minHeight: minHeaderHeight,
    },
    icon: {
      color: 'primary.100',
      fontSize: '24px',
      display: 'flex',
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
        fontSize: 'inherit',
      },
    },
    titles: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
    },
    title: {
      color: 'primary.100',
      fontWeight: '600',
      fontSize: '16px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    subtitle: {
      color: 'c_grey.main',
      fontSize: '14px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      padding: '16px',
    },
    scrollableContent: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
  }
}

export { useStyles }
